<template>
  <div class="accardion__content">
    <div class="accardion__itemsHeader">
      <div class="accardion__itemsTitle" style="width: 33%;">Начало периода</div>
      <div class="accardion__itemsTitle" style="width: 33%;">Окончание периода</div>
      <div class="accardion__itemsTitle" style="width: 33%;">Выкупная сумма</div>
    </div>
    <div v-for="(r, key) in ra" :key="key" class="accardion__items">
      <div class="accardion__itemsText">{{ r.begin_date }}</div>
      <div class="accardion__itemsText">{{ r.end_date }}</div>
      <div
        v-if="typeof r.amount_p === 'undefined' || !project_visible"
        class="accardion__itemsText"
      >
        {{ r.amount }}
      </div>
      <div
        v-else-if="typeof r.amount_p !== 'undefined' && project_visible"
        class="accardion__itemsText"
      >
        {{ r.amount_p }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RaComponent",
  props: ["ra", "project_visible", "project_state"]
};
</script>

<style>
.accardion__itemsHeader,
.accardion__items {
  page-break-inside: avoid;
}
</style>